import PageShell from "@/components/opsiq/PageShell";
import OpsWhatWeDo from "@/components/opsiq/OpsWhatWeDo";

export default function WhatWeDoPage() {
  return (
    <PageShell
      testid="what-we-do-page"
      eyebrow="What we do"
      title={<>Nine practices. <span className="italic">One operating system.</span></>}
      subtitle="From executive dashboards to compliance reporting — OpsIQ delivers every layer of Operational Intelligence a modern leader needs."
    >
      <OpsWhatWeDo />
    </PageShell>
  );
}
